import { cn } from '../../utils/cn'

interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  /** Force amber/white styling (useful for always-dark backgrounds like footer) */
  forceDark?: boolean
  /** Keep the original green artwork even when the app theme is dark. */
  forceLight?: boolean
}

const sizeConfig = {
  sm: { height: 'h-6 sm:h-7' },
  md: { height: 'h-8' },
  lg: { height: 'h-8 sm:h-10' },
}

/**
 * Logo component that uses WebP with PNG fallback and proper dark mode support.
 *
 * In light mode: Shows the original green logo
 * In dark mode: Applies CSS filters to change the green to amber (#f59e0b)
 *
 * The filter uses a CSS class defined in index.css
 */
export function Logo({ className, size = 'md', forceDark = false, forceLight = false }: LogoProps) {
  const config = sizeConfig[size]

  const imgClasses = cn(
    config.height,
    'w-auto object-contain',
    // Apply amber filter in dark mode
    forceDark ? 'logo-amber-filter' : forceLight ? '' : 'dark:logo-amber-filter',
    className
  )

  return (
    <picture>
      <source srcSet="/logo.webp" type="image/webp" />
      <img
        src="/logo.png"
        alt="Optioneer"
        width={160}
        height={40}
        fetchPriority="high"
        className={imgClasses}
      />
    </picture>
  )
}
